export default (params) => {
    if (process.env.NODE_ENV === 'production') {
        window.dataLayer.push(params);
    }
};
